<template>
    <div>
        <div class="combo-warp" v-for="(item, index) in comboItem" :key="index">
            <div class="combo-top">
                <div class="top-left">
                    <img :src="imgArr.comboIcon" class="physio-icon">
                    <div class="physio-title">隐秘处方 {{ index + 1 }} </div>
                    <div>总价 ¥{{ item.totalPrice }}</div>
                </div>
                <div class="top-right" v-if="!isDisabled">
                    <i class="el-icon-delete" @click="removeCombo(index, item.recipeComboId)"></i>
                </div>
            </div>
            <div class="combo-drug">
                <el-row>
                    <el-col :span="6" v-for="obj in item.comboItems" :key="obj.artNo">
                        <div class="grid-content bg-purple">
                            <div class="drug-name">{{ obj.comboItemName }}</div>
                            <div v-if="obj.artNo == '0'">¥{{ obj.totalPrice }}</div>
                            <div v-else>{{ obj.number }}{{ obj.unit }}</div>
                        </div>
                    </el-col>
                </el-row>
                <div class="drug-number">
                    <el-input-number :disabled="isDisabled" :min="1" class="doseNumber-warp" v-model="item.doseNumber"
                        @change="doseNumberChange($event,index, item)" type="text"></el-input-number>
                    <!-- <el-input-number :disabled="status == '4'" :min="1" class="doseNumber-warp" v-model="item.doseNumber"
                        @change="item.totalPrice = formatNumber(item.price * item.doseNumber)"
                        type="text"></el-input-number> -->
                    <span>付</span>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { deepClone, isNull,msgboxWarning } from '@/utils/validateBase'
import { removeRecipe } from '@/api/pricingDetails'
import { imgArr } from '@/assets/images/img'
export default {
    // 定义引入的组件
    components: {},
    props: {
        // 隐秘处方对象
        comboItem: Array,
        page: String,
        isDisabled: Boolean
    },
    //监听属性 类似于data概念
    computed: {
        formatNumber() {
            let self = this;
            return function (val) {
                // 对计算属性进行传参
                if (val) {
                    return self.$toFixed(val);
                }
            };
        },
    },
    data() {
        return {
            imgArr: imgArr
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() { },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 付数改变
         */
        doseNumberChange(num,index){
            console.log(num,index,111);
            let comboItem = deepClone(this.comboItem)
            comboItem[index].totalPrice=this.$bigNumber(comboItem[index].price,'*', num,2)
            this.$emit('updataComboItem', comboItem)
        },  
        /**
         *  移除隐秘处方
         */
        removeCombo(index, id) {
            msgboxWarning(this, {
                message: `是否确定删除该处方？`,
                confirmFn: () => {
                    let comboItem = deepClone(this.comboItem)
                    if (!isNull(id)) {
                        removeRecipe({ recipeId: id, type: '3' }).then(res => {
                            if (res.code == 200) {
                                comboItem.splice(index, 1)
                                this.$emit('updataComboItem', comboItem)
                            }
                        })
                    } else {
                        comboItem.splice(index, 1)
                        this.$emit('updataComboItem', comboItem)
                    }
                },
                cancelFn: () => {
                },
            });
        }

    },
}
</script>
<style lang="less" scoped src="./index.less"></style>